import React from "react";
import DriverShift from "./driverShift";
import GroupItem from "./groupItem";
import RangeItem from "./rangeItem";
import ServiceWork from "./serviceWork";

const templates = {
    group: (item, options) => <GroupItem item={item} options={options} />,
    range: (item, options) => <RangeItem item={item} options={options} />,
    driverShift: (item, options) => <DriverShift item={item} options={options} />,
    serviceWork: (item, options) => <ServiceWork item={item} options={options} />,
};

export default templates;
